'use client';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

const RadioCardGroup = styled(RadioGroupPrimitive.Root, {
    display: 'block',
});
const StyledRadioButton = styled('div', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '$round',
    width: 25,
    height: 25,
    boxShadow: 'inset 0 0 0 1px $colors$gray7',
    flexShrink: 0,
    mr: '$3',
});
const StyledRadioIndicator = styled('div', {
    borderRadius: '$round',
    width: 15,
    height: 15,
    backgroundColor: '$info9',
    transform: 'scale(0)',
});
const StyledRadio = styled(RadioGroupPrimitive.Item, {
    all: 'unset',
    boxSizing: 'border-box',
    userSelect: 'none',
    '&::before': {
        boxSizing: 'border-box',
    },
    '&::after': {
        boxSizing: 'border-box',
    },
    display: 'flex',
    alignItems: 'center',
    borderRadius: '$2',
    boxShadow: 'inset 0 0 0 1px $colors$gray7',
    p: '$3',
    '@hover': {
        '&:hover': {
            boxShadow: 'inset 0 0 0 1px $colors$gray8',
        },
    },
    '&[data-state="checked"]': {
        boxShadow: 'inset 0 0 0 1px $colors$info8, 0 0 0 1px $colors$info8 !important',
        [`& ${StyledRadioIndicator}`]: {
            transform: 'scale(1)',
        },
    },
});
const RadioCard = React.forwardRef((props, forwardedRef) => (React.createElement(StyledRadio, Object.assign({}, props, { ref: forwardedRef }),
    React.createElement(StyledRadioButton, null,
        React.createElement(StyledRadioIndicator, null)),
    props.children)));

export { RadioCard, RadioCardGroup };
